import { ResidentCalendarScreen } from "app/screens/residents/show/ResidentCalendarScreen";

export default function ResidentCalendarPage() {
  return <ResidentCalendarScreen />;
}
